module.exports = __webpack_public_path__ + "static/img/group-6.8c0e544.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/group-6.jpg
// module id = EsoH
// module chunks = 1